import React, { useState } from "react";
import {  RCCGrid, RCCInput, RCCHTMLTextEditor, RCCButton } from "react-common-components";
import LovUsers from "src/components/Lov/Users";
import { useTranslation } from "src/context/Translations/context";
import LovTags from "src/components/Lov/Tags";
import Audit from "src/components/Audit";
import LovMeetingTypes from "src/components/Lov/MeetingTypes";
import LovMeetingRooms from "src/components/Lov/MeetingRooms";
import { TagsTypes } from "src/components/FiltersTagsContainer/interface";
import DateTimePicker from "src/components/DateTimePicker";
import LovMaps from "src/components/Lov/Maps";
import Loader from "src/components/Loader";
import { IMeetingTab } from "../interface";
import { FormMeetingAction } from "../../../interface";

const TabGeneralData: React.FC<IMeetingTab> = ({ 
	data,
	register,
	control,
	errors,
	watch,
	setValue,
	formAction
}) => {
	const { translate} = useTranslation();
	
	const [displayInput, setDisplayInput] = useState(true);

	const isDisabled = formAction === FormMeetingAction.VIEW;
	const isVisible = formAction !== FormMeetingAction.EXECUTE;
	const isCopy = formAction === FormMeetingAction.COPY;

	return(
		<RCCGrid container item 
			justifyContent="center">
			<RCCGrid container item 
				xs={12} 
				sm={10} 
				lg={8}
			>
				<RCCGrid
					container
					justifyContent="flex-end"
				>
					<RCCGrid item>
						<Audit 
							data={data} 
							type="pop" 
							position="left"
						/> 
					</RCCGrid>
				</RCCGrid>
				<RCCGrid container>	
					<input 
						{...register("ara001Id")} 
						name="ara001Id"
						value={data.ara001Id}
						type="hidden"
					/>	
					<input 
						{...register("ara001Finalizada")} 
						name="ara001Finalizada"
						value={data.ara001Finalizada}
						type="hidden"
					/>
					<RCCInput 
						name="ara001Assunto"
						register={register}
						label={translate("Assunto")}
						defaultValue={isCopy ? `(${translate("CÓPIA")}) ${data.ara001Assunto}` : data.ara001Assunto}
						error={errors?.ara001Assunto}
						maxLength={200}
						required
						disabled={isDisabled || !isVisible}
					/>
				</RCCGrid>
				<RCCGrid container spacing={1}>
					<RCCGrid item>
						<DateTimePicker
							control={control}
							label={translate("Data da reunião")}
							defaultValue={new Date(data.ara001Dthrinicio)}
							name="ara001Dthrinicio"
							type="dateTimePicker"
							required
							error={errors.ara001Dthrinicio}
							props={{
								dateTimePicker:{
									disabled:isDisabled || !isVisible
								}
							}}
						/>
					</RCCGrid>
					<RCCGrid item>
						<DateTimePicker
							control={control}
							label={translate("Hora de encerramento")}
							defaultValue={new Date(data.ara001Dthrfim)}
							name="ara001Dthrfim"
							type="timePicker"
							required
							error={errors.ara001Dthrfim}
							props={{
								timePicker:{
									disabled:isDisabled || !isVisible
								}
							}}
							styleInline={
								`&.MuiGrid-root {
									@media(min-width: 600){padding-left: 8px}
								}`
							}
						/>
					</RCCGrid>
				</RCCGrid>
				{isVisible && 
					<RCCGrid container>	
						<RCCGrid container>	
							<LovMeetingTypes
								control={control}
								label={translate("Tipo")}
								name="ara001Taa010Id"
								disabled={isDisabled}
								error={errors.ara001Taa010Id}
								defaultValue={data.ara001Taa010Id?.toString()}
								isClearable
							/>
						</RCCGrid>
						<RCCGrid container>	
							<LovMeetingRooms
								control={control}
								label={translate("Sala")}
								name="ara001Taa008Id"
								required
								disabled={isDisabled}
								error={errors.ara001Taa008Id}
								defaultValue={data.ara001Taa008Id?.toString()}
							/>
						</RCCGrid>
						<RCCGrid container>		
							<LovUsers
								control={control}
								label={translate("Responsável")}
								name="ara001Efa005Id"
								required
								disabled={isDisabled}
								error={errors.ara001Efa005Id}
								defaultValue={data.ara001Efa005Id?.toString()}
							/>
						</RCCGrid>
						<RCCGrid container>		
							<LovMaps
								control={control}
								label={translate("Mapa")}
								name="ara001Mea001Id"
								disabled={isDisabled}
								error={errors.ara001Mea001Id}
								defaultValue={data.ara001Mea001Id?.toString()}
							/>
						</RCCGrid>
						<RCCGrid container>		
							<RCCInput 
								name="ara001Linkexterno"
								register={register}
								label={translate("Link externo")}
								defaultValue={data.ara001Linkexterno}
								error={errors?.ara001Linkexterno}
								maxLength={2000}
								disabled={isDisabled}
							/>
						</RCCGrid>
						<RCCGrid container item sm={3}>		
							<RCCInput 
								name="ara001Diasfinalizar"
								type="number"
								register={register}
								label={translate("Dias para finalizar")}
								defaultValue={data.ara001Diasfinalizar}
								error={errors?.ara001Diasfinalizar}
								max={999}
								min={0}
								disabled={isDisabled}
							/>
						</RCCGrid>
						<RCCGrid container>		
							<LovTags 
								control={control}
								name="tags"
								isClearable
								label={translate("Tags")}
								defaultValue={Array.isArray(data.tags) ? data.tags.join(", ") : data.tags}
								extraParametersOnLoad={{
									use: TagsTypes.MEETINGS
								}}
								extraParametersOnCreate={{
									use: TagsTypes.MEETINGS
								}}
								disabled={isDisabled}
							/>
						</RCCGrid>
					</RCCGrid>
				}
				<RCCGrid container>		
					<RCCHTMLTextEditor
						control={control}
						name="ara001Pauta"
						label={translate("Pauta")}
						defaultValue={data.ara001Pauta||""}
						disabled={isDisabled}
						required
						error={errors.ara001Pauta}
					/>
				</RCCGrid>
				{data.ara001Id !== 0 && 
				<>
					<RCCGrid container>	
						{!isDisabled && (
							<RCCGrid 
								container
								item
								justifyContent="flex-start"
							>	
								<RCCButton
									color="blue"
									icon={{
										name: "copy"
									}}
									layout="default"
									size="sm"
									onClick={() => {
										setValue("ara001Ata", watch("ara001Pauta"));
										setDisplayInput(false);							
										setTimeout(() => {
											setDisplayInput(true);
										}, 200);						
									}}
								>
									{translate("Copiar pauta")}
								</RCCButton>													
							</RCCGrid>
						)}
								
						{displayInput ? (
							<RCCHTMLTextEditor
								control={control}
								name="ara001Ata"
								label={translate("Ata")}
								defaultValue={watch("ara001Ata")}
								disabled={isDisabled}
								error={errors.ara001Ata}
							/>
						): <Loader />}
					</RCCGrid>
				</>	
				}
			</RCCGrid>
		</RCCGrid>
	);
};
export default TabGeneralData;
